<template>
  <div class="produce">
    <div class="headerSearch">
      <div class="sousuo">
        <el-form
          ref="search"
          style="display: flex"
          :model="searchForm"
          label-position="left"
          label-width="90px"
        >
          <el-form-item label="化学品:" style="">
            <el-input
              v-model="searchForm.hxpMc"
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item label="仓库名称:">
            <el-select v-model="searchForm.ckId" filterable placeholder="请选择">
              <el-option
                v-for="item in options2"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="生产日期:">
            <el-col :span="10">
              <el-date-picker
                v-model="searchForm.beginScrq"
                type="date"
                style="width: 100%"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                :picker-options="startTime"
              />
            </el-col>
            <el-col style="text-align: center" class="line" :span="3">-</el-col>
            <el-col :span="10">
              <el-date-picker
                v-model="searchForm.endScrq"
                type="date"
                style="width: 100%"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                :picker-options="endTime"
              />
            </el-col>
          </el-form-item>
          <el-form-item label="状态:" label-width="50px">
            <el-select v-model="searchForm.zt" placeholder="请选择">
              <el-option
                v-for="item in options1"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-button
            v-preventReClick
            class="sousuoButton"
            icon="el-icon-search"
            round
            size="small"
            type="primary"
            @click="handleCurrentChange(1)"
          >搜索</el-button>
          <el-button
            v-preventReClick
            class="chongzhiButton"
            size="small"
            icon="el-icon-refresh-right"
            round
            @click="reset"
          >重置</el-button>
        </el-form>
      </div>
    </div>
    <div
      style="
        margin: auto;
        width: 95%;
        max-width: 1518px;
        background-color: white;
        padding-top: 40px;
        padding-bottom: 57px;
      "
    >
      <div class="tablemes">
        <el-table
          ref="cktable"
          :data="tableData"
          border
          :cell-style="cellStyle"
          :show-overflow-tooltip="true"
          :header-cell-style="{ background: '#F2F2F2' }"
          style="width: 100%"
          :header-cell-class-name="cellClass"
          @selection-change="handleSelectionChange"
          @select-all="checkSelect"
        >
          <el-table-column>
            <template slot="header">
              <el-button
                v-preventReClick
                type="primary"
                class="addButton"
                style="border: none"
                size="mini"
                icon="el-icon-plus"
                @click="addPupShow"
              >新增</el-button>
              <el-button
                v-preventReClick
                size="mini"
                icon="el-icon-plus"
                @click="addEditMes"
              >复制新增</el-button>
              <el-button
                v-preventReClick
                icon="el-icon-upload2"
                size="mini"
                @click="dcexcel"
              >导出</el-button>
            </template>
            <el-table-column
              align="center"
              type="selection"
              width="55"
            />

            <el-table-column
              v-for="(item, i) in table"
              :key="i"
              :show-overflow-tooltip="true"
              align="center"
              :label="item.label"
              :prop="item.key == 'scrq' ? 'scrq' : ''"
              :width="item.key == 'rkbh' ? '180' : ''"
            >
              <template slot-scope="scope">
                <span
                  v-if="item.key != 'bgcs' || scope.row[item.key] == 0"
                  :title="scope.row[item.key]"
                >
                  {{
                    item.key == "rksl" && scope.row["rkslDwLabel"] != null
                      ? scope.row[item.key] +
                        "  (" +
                        scope.row["rkslDwLabel"] +
                        ")"
                      : scope.row[item.key]
                  }}
                </span>
                <a
                  v-else
                  :title="scope.row[item.key]"
                  link
                  href="#"
                  target="_blank"
                >
                  {{ scope.row[item.key] }}
                </a>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="bgcs" label="变更次数">
              <template slot-scope="scope">
                <span
                  v-preventReClick
                  style="cursor: pointer"
                  @click="bgcsClick(scope.row)"
                >{{ scope.row.bgcs }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="ztLabel" label="状态" show-overflow-tooltip>
              <template slot-scope="scope">
                <span style="cursor: pointer">{{ scope.row.ztLabel }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="200px">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.zt != '00'"
                  v-preventReClick
                  type="primary"
                  icon="el-icon-document"
                  size="mini"
                  @click="query(scope.$index, scope.row)"
                >查看</el-button>
                <el-button
                  v-if="scope.row.zt == '00'"
                  v-preventReClick
                  type="primary"
                  icon="el-icon-edit"
                  size="mini"
                  @click="edit(scope.$index, scope.row)"
                >编辑</el-button>
                <el-button
                  v-if="scope.row.zt == '00'"
                  v-preventReClick
                  type="primary"
                  class="deleteButton"
                  icon="el-icon-delete"
                  size="mini"
                  @click="handleDelete(scope.$index, scope.row)"
                >删除</el-button>
                <el-button
                  v-if="scope.row.zt != '00'"
                  v-preventReClick
                  :type="scope.row.zt == '11' ? 'info' : 'warning'"
                  :disabled="scope.row.zt == '11'"
                  icon="el-icon-edit"
                  size="mini"
                  @click="handleChange(scope.$index, scope.row)"
                >变更</el-button>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>

        <el-pagination
          background
          layout="prev,pager,next,jumper,total,sizes"
          :total="total"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pagesize"
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
    </div>
    <bgcs
      ref="bgcsDia"
      :bgwindow="bgwindow"
      :bgcs-t-k-name="bgcsTKName"
      :cur-row-obj="curRowObj"
      :cur_type="cur_type"
      @closeBindWarnStandard="handleCloseBindWarnStandard"
    />
    <produce-pup
      ref="producePup"
      :scrktype="scrktype"
      :leixing="leixing"
      :djsjdisable="djsjdisable"
      :change-type="changeType"
      :bgdisable="bgdisable"
      :djr="djr"
    />
  </div>
</template>
<script>
import ProducePup from './producePup.vue'
import bgcs from '@/components/bgcs'
import {
  getListCkcx,
  getscrkMes,
  exportscrkList,
  deletescrkMes,
  getnbsyztMes,
  userInfofLogin,
  getscrkDetailMes
} from '@/assets/js/common.js'
import {dealDataGy} from "@/utils/ppp";
export default {
  components: { ProducePup, bgcs },
  props: {},
  data() {
    return {
      bgcsTKName: '生产入库',
      curRowObj: {},
      cur_type: 0,
      startTime: {
        disabledDate: (time) => {
          if (this.searchForm.endScrq) {
            return time.getTime() > new Date(this.searchForm.endScrq).getTime()
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      endTime: {
        disabledDate: (time) => {
          if (this.searchForm.beginScrq) {
            return (
              time.getTime() > Date.now() ||
              time.getTime() < new Date(this.searchForm.beginScrq).getTime()
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },

      bgwindow: false,
      // 登记时间
      djsjdisable: false,
      // 变更禁止修改
      bgdisable: true,
      searchForm: {
        hxpMc: '',
        ckId: '',
        beginScrq: '',
        endScrq: '',
        zt: ''
      },
      table: [
        {
          key: 'rkbh',
          label: '入库编号'
        },
        {
          key: 'hxpMc',
          label: '化学品名称'
        },
        {
          key: 'ckmc',
          label: '仓库名称'
        },
        {
          key: 'rksl',
          label: '入库数量'
        },
        {
          key: 'bgyxm',
          label: '保管员'
        },
        {
          key: 'scrq',
          label: '生产日期',
          prop: 'scrq'
        },
        {
          key: 'djsj',
          label: '登记时间'
        }
      ],
      tableData: [], // 表格数据
      total: 0, // 总条数
      currentPage: 1, // 当前页
      pagesize: 10, // 每页的数据条数
      options2: [], // 仓库
      options1: [],
      scrktype: true,
      leixing: '',
      changeType: false,
      multipleSelection: [],
      djr: ''
    }
  },
  computed: {},
  watch: {},
  created() {
    this.search()
    getListCkcx().then((e) => {
      this.options2 = e.data.data
    })
    getnbsyztMes().then((e) => {
      this.options1 = e.data.data
    })
    userInfofLogin().then((e) => {
      this.djr = e.data.data.name
    })
  },
  mounted() {},

  beforeDestroy() {},
  methods: {
    // 点击变更次数
    bgcsClick(curRow) {
      // this.curRowObj = curRow;
      this.$bus.emit('bgcsOpen', curRow, '0')
      this.bgwindow = curRow.bgcs > 0 ? (this.bgwindow = !this.bgwindow) : false
    },
    // 关闭窗口
    handleCloseBindWarnStandard() {
      this.bgwindow = false
    },
    // 当前页码改变时
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.search()
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
      this.search()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
      if (val.length > 1) {
        this.$refs.cktable.clearSelection()
        this.$refs.cktable.toggleRowSelection(val.pop())
      }
    },
    checkSelect(selection) {
      this.$refs.cktable.clearSelection()
    },
    // 取消全选框
    cellClass(row) {
      if (row.columnIndex === 0) {
        return 'disableheadselection'
      }
    },
    async getscrkDetailMess(id) {
      var ret = await getscrkDetailMes(id)
      return ret.data.data
    },
    // 点击复制新增
    addEditMes() {
      // 只有选中为一行才可新增
      if (this.multipleSelection.length == 0) {
        this.$message({
          type: 'info',
          message: '请选择一条数据'
        })
        return
      }
      this.$refs.producePup.dialogVisible = true
      this.getscrkDetailMess(this.multipleSelection[0].id).then((data) => {
        this.$refs.producePup.getformMes(data)
      })
      this.scrktype = false
      this.changeType = false
      this.djsjdisable = false
      this.bgdisable = false
      this.leixing = 'add'
    },
    // 添加
    addPupShow() {
      this.$refs.producePup.getCkxxAndJbr()
      this.$refs.producePup.dialogVisible = true
      this.$refs.producePup.title = '新增生产入库'
      this.scrktype = false
      this.changeType = false
      this.leixing = 'add'
      this.djsjdisable = false
      this.bgdisable = false
    },
    // 查看
    query(index, row) {
      this.$refs.producePup.dialogVisible = true
      this.$refs.producePup.title = '查看生产入库'
      this.getscrkDetailMess(row.id).then((data) => {
        this.$refs.producePup.form = {...data}
      })
      this.$bus.emit('fatherToChil', row, '0')
      this.$refs.producePup.curRowObj = row
      this.scrktype = true
      this.changeType = true
      this.leixing = 'ck'
      this.djsjdisable = true
      this.bgdisable = false
    },

    // 编辑
    edit(index, row) {
      this.$refs.producePup.dialogVisible = true
      this.$refs.producePup.title = '编辑生产入库'
      this.getscrkDetailMess(row.id).then((data) => {
        this.$refs.producePup.getformMes(data, 'edit')
      })

      this.scrktype = false
      this.changeType = false
      this.leixing = 'edit'
      this.djsjdisable = true
      this.bgdisable = false
    },
    // 变更
    handleChange(index, row) {
      this.$refs.producePup.dialogVisible = true
      this.$refs.producePup.title = '变更生产入库'
      this.getscrkDetailMess(row.id).then((data) => {
        this.$refs.producePup.getformMes(data, 'change')
      })
      this.$bus.emit('fatherToChil', row, '0')
      this.scrktype = false
      this.changeType = true
      this.leixing = 'change'
      this.djsjdisable = true
      this.bgdisable = true
    },
    reset() {
      this.pagesize = 10
      this.currentPage = 1
      this.searchForm = {
        hxpMc: '',
        zt: '',
        ckId: '',
        beginTime: '',
        endTime: ''
      }
      this.search()
    },
    async getscrkMess(dataObj) {
      dataObj.param.vdata = await dealDataGy()
      getscrkMes(dataObj).then((e) => {
        this.tableData = e.data.data.rows
        this.total = e.data.data.total
      })
    },
    search() {
      this.getscrkMess({
        page: this.currentPage,
        size: this.pagesize,
        param: {
          hxpMc: this.searchForm.hxpMc,
          zt: this.searchForm.zt,
          ckId: this.searchForm.ckId,
          beginScrq: this.searchForm.beginScrq,
          endScrq: this.searchForm.endScrq
        }
      })
    }, // 点击导出按钮
    dcexcel() {
      exportscrkList({
        page: this.currentPage,
        size: this.pagesize,
        param: {
          hxpMc: this.searchForm.hxpMc,
          zt: this.searchForm.zt,
          ckId: this.searchForm.ckId,
          beginScrq: this.searchForm.beginScrq,
          endScrq: this.searchForm.endScrq
        }
      }).then((e) => {
        const table = '生产入库'
        const a = document.createElement('a')
        const blob = new Blob([e.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        })
        const objectUrl = URL.createObjectURL(blob)
        a.setAttribute('href', objectUrl)
        a.setAttribute('download', table + '.xlsx')
        a.click()
      })
    },
    // 删除行数据
    handleDelete(index, row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deletescrkMes(row.id).then((e) => {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this.search()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      let cellStyle
      if (columnIndex == 9) {
        switch (row.zt) {
          case '01':
            cellStyle = 'color:#6FC89A;font-weight:bold '
            break
          case '11':
            cellStyle = 'color:#43A5E2;font-weight:bold '
            break
          case '00':
            cellStyle = 'color:#000;font-weight:bold '
            break
          default:
            cellStyle = ''
            break
        }
        return cellStyle
      }
    }
  }
}
</script>
<style scoped lang='less'>
.el-table--border {
  z-index: 0;
}
.produce {
  // height: 100%;
  // width: 90%;
  // background-color: white;
  // margin: auto;
  .headerSearch {
    max-width: 1518px;
    width: 95%;
    margin: auto;
    margin-bottom: 11px;
    margin-top: 30px;
    background-color: white;
    padding: 30px 0 20px 0;
    // border: 1px solid red;
    display: flex;
    align-items: center;
    box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    .el-form-item {
      margin-bottom: 10px;
      margin-right: 30px;
      &:last-child {
        width: 90px;
        height: 39px;
        /deep/ .el-button {
          width: 90px !important;
          height: 39px;
          border-radius: 3px;
        }
      }
    }
  }
  .sousuo {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    .sousuoButton {
      width: 90px;
      height: 39px;
      background: #4170ff;
      border-color: #4170ff;
    }
    .chongzhiButton {
      width: 90px;
      height: 39px;
    }
  }
  .tablemes {
    margin: auto;
    width: 90%;
    max-width: 1375px;
    // margin-top: 21px;
    // margin-bottom: 57px;
    // /deep/ .el-table__header {
    //   .el-checkbox {
    //     display: none !important;
    //   }
    // }
    .el-pagination__total {
      margin-left: 8px;
    }
    .el-pagination {
      padding: 10px 0;

      border: 1px solid #ebeef5;
      border-top: 0;
    }
    // .addButton {
    //   color: #fff;
    //   background: #4170ff;
    //   border-radius: 3px;
    //   border-color: #4170ff;
    // }
    .deleteButton {
      background: #ff5721 !important;
      border-color: #ff5721 !important;
    }
    .el-button--warning {
      color: #fff;
      background: #feb800;
      border-radius: 3px;
      border-color: #feb800;
    }
    .el-button--primary {
      color: #fff;
      background: #4170ff;
      border-radius: 3px;
      border-color: #4170ff;
    }
    .el-pager {
      .number {
        background: #4170ff;
        border-color: #4170ff;
      }
    }
  }
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
/deep/ .disableheadselection > .cell .el-checkbox__inner {
  display: none !important;
}
</style>
